export class Storage {
	constructor() {
		this.site = window.englishName;
		this.version = 1.0;
		
		this.initVersion();
	}
	
	initVersion() {
		this.getItem("version").then(res => {
			if (!res || parseInt(res) !== this.version) {
				this.clear();
				return this.setItem("version", this.version);
			}
		});
	}

	setItem(key, value) {
		return localforage.setItem(this.site + "_" + key, value);
	}

	getItem(key) {
		return localforage.getItem(this.site + "_" + key);
	}

	removeItem(key) {
		return localforage.removeItem(this.site + "_" + key);
	}
	
	clear() {
		return localforage.clear();
	}
}
